import React from "react"
import styled from "styled-components"

const StyledWrapper = styled.div`
  margin-bottom: 24px;
`

const StyledCheckBox = styled.input.attrs({
  type: "checkbox",
  name: "remember_me",
  id: "remember_me",
})``

const StyledLabel = styled.label.attrs({
  htmlFor: "remember_me",
})`
  cursor: pointer;
  margin-left: 12px;
`

export const RememberMe = () => {
  return (
    <StyledWrapper>
      <StyledCheckBox />
      <StyledLabel>Remember Me</StyledLabel>
    </StyledWrapper>
  )
}
